// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const StoreIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Store/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M20.609 12v5.87a3.14 3.14 0 0 1-3.13 3.13H7.303a3.14 3.14 0 0 1-3.13-3.13V12"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M20.217 3H4.565S3 9.691 3 10.043a2.355 2.355 0 0 0 2.348 2.348 2.355 2.355 0 0 0 2.348-2.348 2.355 2.355 0 0 0 2.348 2.348 2.355 2.355 0 0 0 2.347-2.348 2.355 2.355 0 0 0 2.348 2.348 2.355 2.355 0 0 0 2.348-2.348 2.355 2.355 0 0 0 2.348 2.348 2.355 2.355 0 0 0 2.348-2.348c0-.352-1.566-7.043-1.566-7.043ZM13.957 16.304h-3.13V21h3.13v-4.696Z"
}));
export default StoreIcon;